import { ActionTypes } from '../../constants/ActionTypes';
import { INews } from '../../interfaces';

// news
export const onGetNews = () => {
  return {
    type: ActionTypes.GET_NEWS,
  };
};

export const fetchNewsSuccess = (news: INews[]) => {
  return {
    type: ActionTypes.FETCH_NEWS_SUCCESS,
    payload: news,
  };
};

export const onGetNewsById = (announcementId: string | undefined) => {
  return {
    type: ActionTypes.GET_NEWS_BY_ID,
    payload: announcementId,
  };
};

export const clearNewsItem = () => {
  return {
    type: ActionTypes.CLEAR_NEWS_ITEM,
  };
};

export const fetchNewsByIdSuccess = (news: INews[]) => {
  return {
    type: ActionTypes.FETCH_NEWS_BY_ID_SUCCESS,
    payload: news,
  };
};
